/**
 * 获取前三个订阅计划名称（体验、个人、团队）
 * 排除"官方"和"企业"计划
 * @param {Array} configList - 订阅计划配置列表
 * @returns {Array<string>} 返回前三个订阅计划名称数组，如 ['体验', '个人', '团队']
 */
export function getFirstThreePlanNames(configList) {
  if (!configList || !Array.isArray(configList)) {
    return ['体验', '个人', '团队']
  }
  
  // 过滤掉"官方"和"企业"计划，取前三个
  const filteredPlans = configList
    .filter(config => {
      const roleName = config.roleName || ''
      return roleName !== '官方' && roleName !== '企业版' && roleName !== '企业'
    })
    .slice(0, 3)
    .map(config => config.roleName || '')
  
  // 如果获取到的计划数量不足3个，使用默认值
  const defaultNames = ['体验', '个人', '团队']
  return filteredPlans.length >= 3 ? filteredPlans : defaultNames.slice(0, filteredPlans.length)
}

/**
 * 获取订阅计划名称映射
 * @param {Array} configList - 订阅计划配置列表
 * @returns {Object} 返回计划名称映射对象，如 { first: '体验', second: '个人', third: '团队' }
 */
export function getPlanNamesMap(configList) {
  const names = getFirstThreePlanNames(configList)
  return {
    first: names[0] || '体验',
    second: names[1] || '个人',
    third: names[2] || '团队'
  }
}

